module.exports = __webpack_public_path__ + "static/media/Full-battery-icon.f43c79b1.svg";